import MortalityControl from "@/modules/MortalityControl/pages/MortalityControl"

export default [
	{
		path: '/controleMortalidade',
		name: 'controleMortalidade',
		component: MortalityControl
	}
];
